export default __webpack_public_path__ + "static/media/travelhospitality.5bb7eb9f.jpeg";